import React from "react";
import { Fail, Success } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";

const iconMap = {
  success: Success,
  fail: Fail,
  csuccess: Success,
  cfail: Fail
};

const ConfirmationBox = ({ addMsg, msg, confirmationType }) => {
  const type = confirmationType?.toLowerCase();
  const icon = iconMap[type];

  return (
    <div className={`mf_confirmation_box ${confirmationType}`}>
      <div className="icon">
        <Success size={60} color={COLOR_VARS.SWIFT_COLOR4} />
      </div>
      <p>{type === "success" && ("Transaction Success") }{type === "fail" && "Transaction Failed"}
        {type === "csuccess" && ("Order Cancelled") }{type === "cfail" && "Order Cancellation Failed"}
      </p>
      <span className="message">{msg}</span>
      <span className="message">{addMsg}</span>
     
    </div>
  );
};

export default ConfirmationBox;

export function ConfirmationBoxSmart({ confirmMessage, cancelMessage }) {
  // Lazy import to avoid changing your original ConfirmationBox import path
  // If you have the original component available, replace with direct import
  const ConfirmationBox = require("./ConfirmationBox").default || require("./ConfirmationBox");

  // Map to the four states you had earlier
  if (confirmMessage === "CFailed" && !cancelMessage)
    return <ConfirmationBox msg={cancelMessage} confirmationType={"CFail"} />;
  if (confirmMessage === "Failed" && !cancelMessage)
    return <ConfirmationBox msg={cancelMessage} confirmationType={"Fail"} />;
  if (confirmMessage === "CFailed" && cancelMessage)
    return <ConfirmationBox msg={cancelMessage} confirmationType={"CFail"} />;
  if (confirmMessage === "Failed" && cancelMessage)
    return <ConfirmationBox msg={cancelMessage} confirmationType={"Fail"} />;
  if (confirmMessage === "CSuccess")
    return <ConfirmationBox msg={cancelMessage} confirmationType={"CSuccess"} />;
  if (confirmMessage === "Success")
    return <ConfirmationBox msg={cancelMessage} confirmationType={"Success"} />;
  return null;
}

